module.exports = __webpack_public_path__ + "contacts-cbf4f629/video-c942510ba422e55ebbc79788086e1b55.svg";